/**
 * By default, Object.keys returns the keys of an object as a string array.
 * Use this function to return them as an array of string literals which
 * are a union type of the keys of the object.
 * @param {object} obj - The object whose keys are to be returned
 */
const getKeys = Object.keys;
export default getKeys;
